import { gqlRepWorksheetFieldOrder } from '@minecraft.graphql-types';
import { useTranslation } from '@blocs.i18n';
import { SelectOption } from '../types';

export const useViewByDateOptions = (): Array<SelectOption> => {
  const { t } = useTranslation();

  return [
    { value: gqlRepWorksheetFieldOrder.dueDate, label: t('common:label.option.scheduleDueDate') },
    { value: gqlRepWorksheetFieldOrder.receivedAt, label: t('common:label.option.receivedDate') },
  ];
};
